import IcQuestion from 'assets/images/backoffice/capital/ic-question-mark.svg';
import React, { Component } from 'react';
import InfoCard from './InfoCard';
import styles from './InfoCard.css';

class AdditionalCost extends Component {
  state = {
    showInfo: false,
  };

  render() {
    return (
      <InfoCard
        title="Biaya Tambahan"
        icon={<img src={IcQuestion} className={styles.question} />}
      >
        <div className={styles['additional-cost-wrapper']}>
          <div className={styles['additional-text-wrapper']}>
            <div className={styles.provisi}>
              <p className={styles['additional-text']}>Biaya Provisi</p>
              <div className={styles['tooltip-wrapper']}>
                <p
                  className={styles.info}
                  onMouseEnter={() => this.setState({ showInfo: true })}
                  onMouseLeave={() => this.setState({ showInfo: false })}
                >
                  i
                </p>
                {this.state.showInfo && (
                  <div className={styles['tooltip-content']}>
                    Biaya provisi adalah <b>biaya potongan di muka</b> dari
                    jumlah dana yang Anda pinjam
                  </div>
                )}
              </div>
            </div>
            <p className={styles['additional-text']}>3%</p>
          </div>
          <div className={styles['additional-text-wrapper']}>
            <p className={styles['additional-text']}>Biaya Keterlambatan</p>
            <p className={styles['additional-text']}>3%</p>
          </div>
          <div className={styles['content-list-item']}>
            <p className={styles['additional-text']}>
              Biaya untuk pelunasan dipercepat
            </p>
            <ul className={styles['list-item']}>
              <li>5% untuk pinjaman ≤ 6 bulan</li>
              <li>2% untuk pinjaman &gt; 6 bulan</li>
            </ul>
          </div>
        </div>
      </InfoCard>
    );
  }
}

export default AdditionalCost;
